import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import {
  checkAnyRoute,
  fallbackRedirectGuard,
  landingRedirectGuard,
  routeOutsideStudioGuard,
} from './app-route.guards';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [MsalGuard, landingRedirectGuard],
    children: [],
  },
  {
    path: 'agents',
    loadComponent() {
      return import('./pages/agents-page/agents-page').then((x) => x.AgentsPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'agent-studio',
    loadComponent() {
      return import('./pages/agent-studio-page/agent-studio-page').then((x) => x.AgentStudioPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'agent-studio/:id',
    loadComponent() {
      return import('./pages/agent-studio-page/agent-studio-page').then((x) => x.AgentStudioPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'knowledge-base',
    loadComponent() {
      return import('./pages/knowledge-base-page/knowledge-base-page').then((x) => x.KnowledgeBasePage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'knowledge-base/:name',
    loadComponent() {
      return import('./pages/index-detail-page/index-detail-page').then((x) => x.IndexDetailPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'tests',
    loadComponent() {
      return import('./pages/tests-page/tests-page').then((x) => x.TestsPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'tests/:id',
    loadComponent() {
      return import('./pages/test-detail-page/test-detail-page').then((x) => x.TestDetailPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'logs',
    loadComponent() {
      return import('./pages/logs-page/logs-page').then((x) => x.LogsPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'analytics',
    loadComponent() {
      return import('./pages/analytics-page/analytics-page').then((x) => x.AnalyticsPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'settings',
    loadComponent() {
      return import('./pages/settings-page/settings-page').then((x) => x.SettingsPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'content',
    loadComponent() {
      return import('./pages/content-page/content-page').then((x) => x.ContentPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'content/create',
    loadComponent() {
      return import('./pages/content-page/create-content/create-content').then((x) => x.CreateContentPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'call/:id',
    loadComponent() {
      return import('./pages/call-page/call-page').then((x) => x.CallPage);
    },
    canActivate: [MsalGuard],
    canMatch: [checkAnyRoute],
  },
  {
    path: 'login-failed',
    loadComponent: () =>
      import('./components/access-denied/access-denied.component').then(
        (m) => m.AccessDeniedComponent,
      ),
  },
  {
    path: '**',
    canActivate: [routeOutsideStudioGuard, MsalGuard, fallbackRedirectGuard],
    children: [],
  },
];
